import { combineReducers } from '@reduxjs/toolkit';
import globalReducer from './slices/global.slice';
import loanDetailReducer from './slices/loanDetail.slice';
import loansReducer from './slices/loans.slice';
import loanOfficersReducer from './slices/loanOfficers.slice';
import loanApplicationReducer from './slices/loanApplication.slice';

const rootReducer = combineReducers({
  global: globalReducer,
  loanDetail: loanDetailReducer,
  loans: loansReducer,
  loanOfficers: loanOfficersReducer,
  loanApplication: loanApplicationReducer,
});

export default rootReducer;
